// extracted by mini-css-extract-plugin
export var nav = "main-navigation-module--nav--8NwjF";
export var navList = "main-navigation-module--nav-list--J-AE7";